import { render, staticRenderFns } from "./bugEchartsPhone.vue?vue&type=template&id=59c39e8a&scoped=true&"
import script from "./bugEchartsPhone.vue?vue&type=script&lang=js&"
export * from "./bugEchartsPhone.vue?vue&type=script&lang=js&"
import style0 from "./bugEchartsPhone.vue?vue&type=style&index=0&id=59c39e8a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c39e8a",
  null
  
)

export default component.exports